"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWidgetLinkEditor = void 0;
var CorrectLink_1 = __importDefault(require("@CommonFrontendBackend/Utils/CorrectLink"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./LinkEditor.css"));
var ImageWidgetLinkEditor = function (_a) {
    var _b;
    var element = _a.element, onClose = _a.onClose;
    var _c = __read((0, react_1.useState)(undefined), 2), localHref = _c[0], setLocalHref = _c[1];
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var handleClickRemoveLink = function () {
        var updateData = {
            action: "update",
            path: widgetManager.getPath(element),
            toUpdate: {
                href: "",
            },
        };
        setLocalHref(undefined);
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
        onClose();
    };
    var saveLink = function () {
        if (localHref != undefined) {
            var correctedLink = (0, CorrectLink_1.default)(localHref);
            var updateData = {
                action: "update",
                path: widgetManager.getPath(element),
                toUpdate: {
                    href: correctedLink,
                },
            };
            setLocalHref(undefined);
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("image", updateData));
        }
        onClose();
    };
    var handleClickSaveLink = function () {
        saveLink();
    };
    var handleTextInputKeyDown = function (event) {
        if (event.key === kaleidoscope_1.KeyType.Enter) {
            saveLink();
        }
        if (event.key === kaleidoscope_1.KeyType.Escape) {
            onClose();
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", paddingLeft: "xs", gap: "xxs" },
        react_1.default.createElement(kaleidoscope_1.TextInput, { label: "URL to link from image", labelHidden: true, theme: kaleidoscope_1.TextInputTheme.Dark, variant: kaleidoscope_1.TextInputVariant.Borderless, size: kaleidoscope_1.TextInputSize.XSmall, value: (_b = localHref !== null && localHref !== void 0 ? localHref : element.data.href) !== null && _b !== void 0 ? _b : "", onChange: setLocalHref, placeholder: "Paste your link here", className: styles.textInput, onKeyDown: handleTextInputKeyDown }),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Tick, null), onClick: handleClickSaveLink }),
        react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.Unlink, null), onClick: handleClickRemoveLink })));
};
exports.ImageWidgetLinkEditor = ImageWidgetLinkEditor;
